import React from 'react';
import Reflux from 'reflux';
import hoistNonReactStatic from 'hoist-non-react-statics';

const mapActions = actions => {
  const boundActions = {};
  Object.keys(actions).forEach(actionName => {
    const action = actions[actionName];
    boundActions[actionName] = function() {
      return action(...arguments);
    };
  });
  return boundActions;
};

const shallowEquals = (subState, state) => {
  return Object.keys(subState).every(key => {
    return subState[key] === state[key];
  });
};

export const connect = (mapStateToProps = [], mapActionToProps = {}) => {
  const _storeListeners = [];

  return WrappedComponent => {
    class EnhancedComponent extends React.Component {
      state = mapActions(mapActionToProps);

      _listenToStoreWithMapper([store, mapper]) {
        _storeListeners.push(
          store.listen(state => {
            const newState = mapper(state, this.props);
            if (!shallowEquals(newState, this.state)) {
              this.setState(newState);
            }
          })
        );
        this.setState(mapper(store.getInitialState(), this.props));
      }

      componentWillMount() {
        mapStateToProps.forEach(storeMapper => {
          this._listenToStoreWithMapper(storeMapper);
        });
      }

      componentWillUnmount() {
        _storeListeners.forEach(unsub => unsub());
      }

      render() {
        return <WrappedComponent {...this.props} {...this.state} />;
      }
    }
    return hoistNonReactStatic(EnhancedComponent, WrappedComponent);
  };
};

export const createRefluxStore = StoreClass => {
  const store = {};
  const actions = [];

  Object.getOwnPropertyNames(StoreClass.prototype).forEach(name => {
    const method = StoreClass.prototype[name];
    if (method instanceof Function) {
      store[name] = method;
      actions.push(name);
    }
  });

  store.state = { ...StoreClass.state } || {};
  store.getInitialState = function() {
    return this.state;
  };

  store.set = function(state) {
    this.state = {
      ...this.state,
      ...state
    };
    this.trigger(this.state);
  };

  const storeActions = Reflux.createActions(actions);
  store.listenables = [storeActions];
  const refluxStore = Reflux.createStore(store);
  return {
    actions: storeActions,
    store: refluxStore
  };
};



// WEBPACK FOOTER //
// ./src/js/Util/refluxConnector.js